// extracted by mini-css-extract-plugin
module.exports = {"informationSectionWrapper":"styles_informationSectionWrapper__2_l68","informationSection":"styles_informationSection__mEnEt"};